var Tables = (function() {
  /*"use strict"; */ // Start of use strict

  var
    checkboxCheckAll = null,
    checkboxes = null,
    actionBtns = null,
    options = {},
    defaults = {
      actionBtnSelector: 'button',
      actionBtnClass: 'is-disabled',
      checkboxAllSelector: '[data-selectall]',
      checkboxSelector: '[data-select]'
    };

  var setOptions = function setOptions(config) {
    if (typeof config === 'object') {
      for (var key in defaults) {
        if (!defaults.hasOwnProperty(key)) { continue; }
        options[key] = (typeof config[key] === 'undefined' ? defaults[key] : config[key]);
      }
    }
  };

  var getElements = function getElements() {
    checkboxCheckAll = document.querySelector(options.checkboxAllSelector);
    checkboxes = document.querySelectorAll(options.checkboxSelector).toArray();
    actionBtns = document.querySelectorAll(options.actionBtnSelector).toArray();
  };

  var enableDownload = function enableDownload(btns) {
    btns.forEach(function(btn) {
      btn.classList.remove(options.actionBtnClass);
      return btn.disabled = false;
    });
  };

  var disableDownload = function disableDownload(btns) {
    btns.forEach(function(btn) {
      btn.classList.add(options.actionBtnClass);
      return btn.disabled = true;
    });
  };

  var selectAll = function selectAll(self, checkboxes) {
    checkboxes.forEach(function(checkbox) {
      if ('createEvent' in document) {
        var evt = document.createEvent('HTMLEvents');
        evt.initEvent('change', false, true);
        checkbox.dispatchEvent(evt);
      } else {
        checkbox.fireEvent('onchange');
      }

      return self.checked ? checkbox.checked = true : checkbox.checked = false;
    });
  };

  var checkSelectAll = function checkSelectAll(checkbox) {
    return checkbox.checked = true;
  };

  var uncheckSelectAll  = function uncheckSelectAll(checkbox) {
    return checkbox.checked = false;
  };

  var init = function init(config) {
    setOptions(config);
    getElements();

    checkboxes.forEach(function(checkbox) {
      checkbox.addEventListener('change', function() {
        setTimeout(function() {
          var checkedCheckboxes = document.querySelectorAll('.checkbox-select:checked').toArray();

          if (checkedCheckboxes.length > 0) {
            enableDownload.call(checkbox, actionBtns);
          } else if (checkedCheckboxes.length === 0) {
            disableDownload.call(checkbox, actionBtns);
          }

          if (checkedCheckboxes.length === checkboxes.length) {
            checkSelectAll(checkboxCheckAll);
          } else if (checkedCheckboxes.length < checkboxes.length) {
            uncheckSelectAll(checkboxCheckAll);
          }
        }, 0);
      });
    });

    checkboxCheckAll.addEventListener('change', function() {
      selectAll(this, checkboxes);
    });
  };

  return { init: init };
})();